/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateWhatsAppStore } from '../../axios/candidateWhatsAppStore'
import type {
	CandidateWhatsAppStoreError,
	CandidateWhatsAppStorePathParams,
	CandidateWhatsAppStoreRequest,
	CandidateWhatsAppStoreResponse,
} from '../../types/CandidateWhatsAppStore'

export const candidateWhatsAppStoreMutationKey = () => [{ url: '/candidates/:candidateId/whatsapp' }] as const

export type CandidateWhatsAppStoreMutationKey = ReturnType<typeof candidateWhatsAppStoreMutationKey>

export type CandidateWhatsAppStoreVariables = {
	candidateId: CandidateWhatsAppStorePathParams['candidateId']
	data: CandidateWhatsAppStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::store */
export function useCandidateWhatsAppStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateWhatsAppStoreResponse,
		AxiosError<CandidateWhatsAppStoreError>,
		CandidateWhatsAppStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateWhatsAppStoreMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateWhatsAppStoreVariables) =>
			candidateWhatsAppStore(candidateId, data, config).then(res => res.data),
		...options,
	})
}
